import { Observable } from 'rxjs';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent,
  HttpEventType,
} from '@angular/common/http';

import * as fromRoot from '../../reducers';
import * as layout from '../actions/layout';
import { tap, catchError, finalize } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

@Injectable()
export class ProgressInterceptor implements HttpInterceptor {
  constructor(private store: Store<fromRoot.State>) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const handleObs: Observable<HttpEvent<any>> = next.handle(req);

    this.store.dispatch(new layout.ShowProgressBar());
    return handleObs.pipe(
      finalize(() => {
        this.store.dispatch(new layout.HideProgressBar());
      })
    );
  }
}
